import { Component, Input } from '@angular/core';
import { IOdbBillProductSplit } from '@dch/billing-business-logic';

@Component({
  selector: 'my-bill-odb-vat-product-split',
  templateUrl: './odb-vat-product-split.component.html',
  standalone: false,
})
export class OdbVatProductSplitComponent {
  @Input() productSplit: Array<IOdbBillProductSplit>;
  @Input() totalAmount: string;
}
